import { useClientInformationQuery } from "../new/query";
import ClientInformationSkeleton from "./skeletons/clientinformationskeleton";
import { Button } from "react-bootstrap";
import InsetAlert from "./insetalert";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useRecordRecentClient } from "../new/recent-clients.query";

const ClientInformationNew = ({MedcaidId}) => {
    const query = useClientInformationQuery(MedcaidId);
    const { mutate: recordRecentClient } = useRecordRecentClient();
    const lastRecordedRecentClientRef = useRef(null);
    const navigate = useNavigate();

    const location = useLocation();
    const decodedPath = decodeURIComponent(location.pathname);

    const incidents = decodedPath === `/Client/Client/${MedcaidId}`;

    const safeMedId = encodeURIComponent(MedcaidId);

    useEffect(() => {
        const recentClientKey = `client:${MedcaidId}`;

        if(query.data){
            if (lastRecordedRecentClientRef.current === recentClientKey) {
                return;
            }

            lastRecordedRecentClientRef.current = recentClientKey;
            recordRecentClient({
                medicaidid: MedcaidId
            });
        }
    },[MedcaidId, query.data, recordRecentClient]);

    return(
        query.isLoading
        ?
            <ClientInformationSkeleton boxCount={6} />
        :
            <div className="clientInformation">
            {
                query.error
                ?
                    <InsetAlert error={query.error} dismissible={false} style={{width: '100%'}}/>
                :
                    query.data !== null
                    &&
                    <>
                        <h3 className="clientInformationTitle">
                            Client Information
                        </h3>
                        <div className="infoItemBox">
                                <h5>Name</h5>
                                <p className="infoItemDataBody">{query.data.name}</p>
                            </div>
                            <div className="infoItemBox">
                                <h5>County of Residence</h5>
                                <p className="infoItemDataBody">{query.data.countyofresidence}</p>
                            </div>
                            <div className="infoItemBox">
                                <h5>Gender</h5>
                                <p className="infoItemDataBody">{query.data.gender}</p>
                            </div>
                            <div className="infoItemBox">
                                <h5>Medicaid #</h5>
                                <p className="infoItemDataBody">{query.data.medicaidid}</p>
                            </div>
                            <div className="infoItemBox">
                                <h5>Date of Birth</h5>
                                <p className="infoItemDataBody">{query.data.dateofbirth}</p>
                            </div>
                            <div className="infoItemBox">
                                <h5>Login Name</h5>
                                <p className="infoItemDataBody">{query.data.loginname}</p>
                            </div>
                            <div className="infoItemBox">
                                {
                                    incidents
                                    ?
                                        <>
                                            <h5>Incidents</h5>
                                            <p className="infoItemDataBody">
                                                <Button type="button" variant="link" className="p-0" style={{textDecoration: 'none',fontSize: '0.9em'}} onClick={() => navigate(`/Client/Client/${safeMedId}/incidents`)}>View Incidents</Button>
                                            </p>
                                        </>
                                    :
                                        <>
                                            <h5>Applications</h5>
                                            <p className="infoItemDataBody">
                                                <Button type="button" variant="link" className="p-0" style={{textDecoration: 'none',fontSize: '0.9em'}} onClick={() => navigate(`/Client/Client/${safeMedId}`)}>View Applications</Button>
                                            </p>
                                        </>
                                }
                            </div>
                    </>

            }
            <Button type="button" variant="link" className="p-0" style={{textDecoration: 'none',fontSize: '0.9em'}} onClick={() => navigate('/Client/ClientSearch', { state: { restoreClientSearch: true } })}>Return to Client Search</Button>
        </div>
    )
    
}

export default ClientInformationNew;
